import React from 'react';
export function CreateIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__1db58__clip0)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 .586L23.414 5 21 7.414V22H10v-2h9V9.414L7.562 20.852l-5.19 2.076-1.3-1.3 2.076-5.19L14.586 5H4v9H2V3h14.586L19 .586zM4.852 17.562l-1.057 2.643 2.643-1.057L20.586 5 19 3.414 4.852 17.562z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__1db58__clip0"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}